// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__dHLGD","sendOtp":"AuthorizeToLogin_sendOtp__12Fsp"};